module.exports = __webpack_public_path__ + "img/login.5d169556.jpg";